import React, { useEffect, useState } from 'react';
import { getSessions } from '../../api/client';

interface Session {
  id: string;
  title: string;
  updated_at: string;
}

interface SessionListProps {
  accountId: string | null;
  selectedSessionId: string | null;
  onSelectSession: (sessionId: string) => void;
  onNewChat: () => void;
}

const SessionList: React.FC<SessionListProps> = ({ accountId, selectedSessionId, onSelectSession, onNewChat }) => {
  const [sessions, setSessions] = useState<Session[]>([]);

  useEffect(() => {
    if (accountId) {
      getSessions(accountId)
        .then(data => setSessions(Array.isArray(data) ? data : []))
        .catch(err => {
          console.error("Failed to load sessions", err);
          setSessions([]);
        });
    } else {
      setSessions([]);
    }
  }, [accountId, selectedSessionId]); // Refresh when account or session changes

  // Expose a refresh method or refresh on new chat?
  // For now, we rely on parent to trigger re-renders or we add a reload trigger.
  // Actually, we should reload when a new session is created.

  return (
    <div className="session-list" style={{ marginTop: '1rem', borderTop: '1px solid #1f1f23', paddingTop: '1rem' }}>
      <div className="session-list-header">
        <h4>Previous Chats</h4>
        <button onClick={onNewChat} className="aw-btn-primary aw-btn-sm">
          + New
        </button>
      </div>
      <div style={{ overflowY: 'auto', flex: '1 1 auto' }}>
        <ul className="session-list-items">
          {sessions.map(session => {
            const label = session.title.length > 35 ? session.title.slice(0, 35) + '…' : session.title;
            return (
              <li
                key={session.id}
                onClick={() => onSelectSession(session.id)}
                className={`session-list-item${session.id === selectedSessionId ? ' active' : ''}`}
                title={session.title}
              >
                {label}
              </li>
            );
          })}
          {sessions.length === 0 && (
            <li style={{ padding: '0.5rem', color: '#666', fontStyle: 'italic', fontSize: '0.8125rem' }}>No history</li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default SessionList;
